"use strict";
/*
 * Created on 10 01 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DomainObject_1 = require("../DomainObject");
/**
 * Results of a query along with applied overview settings.
 *
 * @author Radek Beran
 */


var ResultWithOverview =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ResultWithOverview, _DomainObject_1$Domai);

  function ResultWithOverview(result, overview) {
    var _this;

    _classCallCheck(this, ResultWithOverview);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResultWithOverview).call(this));
    _this.result = result;
    _this.overview = overview;
    return _this;
  }

  _createClass(ResultWithOverview, [{
    key: "withResult",
    value: function withResult(result) {
      return this.copy('result', result);
    }
  }, {
    key: "withOverview",
    value: function withOverview(overview) {
      return this.copy('overview', overview);
    }
  }, {
    key: "mapFilter",
    value: function mapFilter(f) {
      return new ResultWithOverview(this.result, this.overview.mapFilter(function (fil) {
        return f(fil);
      }));
    }
    /**
     * Creates empty result list with given overview settings.
     * Total count in overview's pagination is set to 0 if pagination is specified.
     * @param overview
     */

  }], [{
    key: "empty",
    value: function empty(overview) {
      return new ResultWithOverview(immutable_1.List(), overview.withPagination(overview.pagination !== null ? overview.pagination.withTotalCount(0) : null));
    }
  }]);

  return ResultWithOverview;
}(DomainObject_1.DomainObject);

exports.ResultWithOverview = ResultWithOverview;